// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4QwDG","container":"styles_container__xniL8","itemTitle":"styles_itemTitle__o_cOk","checkmark":"styles_checkmark__J3a5W"};